import React from 'react';
import ServiceTemplate from '../../components/ServicePage/ServiceTemplate';

const PCIDSS: React.FC = () => {
  const sections = [
    {
      title: 'PCI DSS Compliance Overview',
      content: 'The Payment Card Industry Data Security Standard (PCI DSS) is a set of security standards designed to ensure that all companies that accept, process, store or transmit credit card information maintain a secure environment. Our comprehensive PCI DSS compliance services help organizations achieve and maintain compliance while reducing the risk of data breaches.',
      benefits: [
        'Comprehensive gap analysis and remediation planning',
        'Expert guidance through all 12 PCI DSS requirements',
        'Network segmentation and security architecture review',
        'Vulnerability scanning and penetration testing',
        'Policy development and employee training programs'
      ]
    },
    {
      title: 'Our PCI DSS Services',
      content: 'We provide end-to-end PCI DSS compliance services tailored to your organization\'s specific needs and merchant level requirements.',
      benefits: [
        'Pre-assessment and readiness evaluation',
        'Qualified Security Assessor (QSA) led assessments',
        'Self-Assessment Questionnaire (SAQ) completion support',
        'Compensating controls development',
        'Ongoing compliance monitoring and maintenance'
      ]
    },
    {
      title: 'Implementation Process',
      content: 'Our proven methodology ensures efficient and effective PCI DSS compliance implementation with minimal business disruption.',
      benefits: [
        'Initial scoping and cardholder data flow mapping',
        'Security control implementation and testing',
        'Documentation and evidence collection',
        'Internal audit and pre-assessment validation',
        'Final assessment and certification support'
      ]
    }
  ];

  const sidebarInfo = [
    {
      title: 'Compliance Timeline',
      content: 'Typical PCI DSS compliance projects take 3-6 months depending on organization size and current security posture.'
    },
    {
      title: 'Merchant Levels',
      content: 'We support all merchant levels (1-4) with appropriate compliance requirements and validation methods.'
    },
    {
      title: 'Ongoing Support',
      content: 'Annual compliance validation, quarterly vulnerability scans, and continuous monitoring services available.'
    }
  ];

  return (
    <ServiceTemplate
      title="PCI DSS Compliance"
      subtitle="Comprehensive Payment Card Industry Data Security Standard compliance services to protect cardholder data and maintain secure payment processing environments."
      sections={sections}
      ctaTitle="Achieve PCI DSS Compliance"
      ctaDescription="Protect your payment processing environment and avoid costly penalties with our expert PCI DSS compliance services."
      sidebarInfo={sidebarInfo}
    />
  );
};

export default PCIDSS;

